export interface IUpdateUserRequestDto {
    description: string | null,
    mail: string,
    name: string | null,
    surname: string | null,
    username: string
}

export class UpdateUserRequest implements IUpdateUserRequestDto {
    public description: string | null;
    public mail: string;
    public name: string | null;
    public surname: string | null;
    public username: string;

    constructor(description: string | null, mail: string, name: string | null, surname: string | null, username: string){
        this.description = description;
        this.mail = mail;
        this.name = name;
        this.surname = surname;
        this.username = username;
    }
}